import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=1976ca09"
import script from "./CSelect.vue?vue&type=script&lang=ts"
export * from "./CSelect.vue?vue&type=script&lang=ts"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=1976ca09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports